import GridViewIcon from '@mui/icons-material/GridView'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'

const ViewToggle = ({ value, onChange, className }) => {
    return (
        <div
            className={`viewToggle ${className || ''}`}
            role="group"
            aria-label="Вид списка товаров"
        >
            <button
                type="button"
                className={`viewToggle__btn ${value === 'plate' ? 'is-active' : ''}`}
                onClick={() => onChange('plate')}
                aria-label="Плитка"
                aria-pressed={value === 'plate'}
                title="Плитка"
            >
                <GridViewIcon />
            </button>

            <button
                type="button"
                className={`viewToggle__btn ${value === 'list' ? 'is-active' : ''}`}
                onClick={() => onChange('list')}
                aria-label="Список"
                aria-pressed={value === 'list'}
                title="Список"
            >
                <FormatListBulletedIcon />
            </button>
        </div>
    )
}

export default ViewToggle
